// extracted by mini-css-extract-plugin
module.exports = {"container":"_16WQRjA5RsNt-nNbQWOhB_","quick-links-title":"_2Kt9G7h6ItMzCZApC38qYL","quickLinksTitle":"_2Kt9G7h6ItMzCZApC38qYL"};